import LoginForm from "../components/LoginForm";
import { fetchHomeLinks } from "../../home/service/home_service";
import useHomeStore from "../../../store/homeStore";
import { useEffect, useState } from "react";
import useDocumentTitle from "../../../shared/customHooks/useDocumentTitle";
import { useLocation, useNavigate } from "react-router-dom";
import { resolveForgotPasswordLink } from "../service/auth_service";
import useAuthStore from "../../../store/authStore";
import useUserContextStore from "../../../store/userContextStore";
import { SecurityQuestionCheck } from "../../../shared/components/SecurityQuestionCheck";

const LoginPage = () => {
  useDocumentTitle('Home');
  const location = useLocation();
  const navigate = useNavigate();
  const setLinks = useHomeStore((state)=> state.setLinks);
  const logout = useAuthStore((state)=> state.logout);
  const [context, setContext] = useState(null);

  const setUserContext = useUserContextStore((state)=>state.setUserContext);
  const getHomeLinks = async() => {
    try{
      const response = await fetchHomeLinks();
      setLinks(response.data);
    }
    catch{
      setLinks(null);
    }
  }
  useEffect(()=>{
    logout();
    getHomeLinks();
  },[])

  useEffect(()=>{
    if(!window.location.href.includes("param") && window.location.pathname === "/"){
      setUserContext(null);
    }
  },[window])

  useEffect(() => {
    const search = String(location.search || "");
    if (!search) return;

    const params = new URLSearchParams(search);
    const param = params.get("param");
    const param1 = params.get("param1");
    if (!param || !param1) return;

    let cancelled = false;

    const resolveLink = async () => {
      try {
        const response = await resolveForgotPasswordLink(param, param1);
        if (cancelled) return;

        const data = response?.data || {};
        const status = String(data?.status ?? data?.Status ?? "").toUpperCase();
        if (status !== "SUCCESS") return;

        const userId = Number(data?.userId ?? data?.UserId ?? 0) || 0;
        const roleId = Number(data?.roleId ?? data?.RoleId ?? 0) || 0;
        const emailAddress = String(data?.emailAddress ?? data?.EmailAddress ?? data?.userName ?? data?.UserName ?? "").trim();
        const resetPasswordUniqueID = String(data?.resetPasswordUniqueID ?? data?.ResetPasswordUniqueID ?? param1).trim();
        const tempPassword = String(data?.tempPassword ?? data?.TempPassword ?? "").trim();

        if (!userId || !resetPasswordUniqueID) return;

        window.__USER_PROFILE_CONTEXT__ = {
          userProfileType: "ChangeForgotPassword",
          currentUserId: btoa(userId),
          userId:btoa(userId),
          contactId: btoa(userId),
          userName: emailAddress,
          roleId,
          resetPasswordUniqueID,
          tempPassword,
          passwordTemporary: true,
          isTempPasswordActive: true,
        };

        setUserContext(window.__USER_PROFILE_CONTEXT__)
        setContext(window.__USER_PROFILE_CONTEXT__)

        //navigate(`/UserProfile/${userId}/password`, { replace: true });
      } catch(err) {
        // Ignore and keep the user on the login page.
        console.log("ERROR:", err);
      }
    };

    resolveLink();
    return () => {
      cancelled = true;
    };
  }, [location.search, navigate]);
  return (
    <div className="row" style={{ margin: 0 }}>
      {context?.userProfileType === "ChangeForgotPassword" ?
        <SecurityQuestionCheck/> :
        <>
        <section className="col-md-6 welcome-text">
        <h3>Login</h3>
        <div className="line-bar"></div>
        <p>
          This portion of this site is exclusively for use by clients of
          Beatrice. If you need assistance with accesing the portal or would
          like to contact us set up access please email
          <br/>
          <a href="mailto:clientservices@beatriceadvisors.com">
            clientservices@beatriceadvisors.com
          </a>
        </p>
      </section>

      <section id="SectionloginForm" className="col-md-6" style={{display:'block'}}>
        <LoginForm setContext={setContext}/>
      </section>
        </>
        }
    </div>
  );
};

export default LoginPage;

